import React from "react";
import { Col, Row } from "react-bootstrap";
import { ProductReferenceField } from "../../CompoundFields/ProductReferenceField";
import { DescriptionField } from "../../CompoundFields/DescriptionField";
import { ContentLanguageForm } from "../../Parts/ContentLanguageForm";
import { Condition } from "../../Conditionals/Condition";
import { TranslationForm } from "../../Parts/TranslationForm";
import { SpecialForm } from "../../Parts/SpecialForm";
// import { PrintForm } from "../../Parts/PrintForm";

export const Advertisement = () => {
    return <Row>
        <hr/>
        <Col md={ 12 }>
            <h2>Advertisement</h2>
            <ProductReferenceField
                elementType="advertisement"
            />
        </Col>

        <DescriptionField
            parent="Advertisement"
        />

        <ContentLanguageForm
            elementType="advertisement"
        />

        <Condition when="Content Language Option" is="Translation">
            <TranslationForm
                elementType="advertisement"
            />
        </Condition>
        <Condition when="Content Language Option" is="Special">
            <SpecialForm/>
        </Condition>

        {/*<PrintForm/>*/}
    </Row>;
}